import { useState } from 'react';
import { axiosInstance } from '../services/api';

export const useFamilyRelationships = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const createRelationship = async (payload) => {
    setLoading(true);
    setError(null);

    try {
      const response = await axiosInstance.post('/genealogy/people/create_with_relationship/', payload);

      if (!response.data) {
        throw new Error('No response data received');
      }

      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'Unknown API error';
      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  // Pattern 1: One person + new related person
  const addRelatedPerson = async (existingPersonId, relationshipType, newPersonData) => {
    const payload = {
      existing_person_id: existingPersonId,
      relationship_type: relationshipType,
      new_person_data: newPersonData,
      family_context: "auto"
    };

    return await createRelationship(payload);
  };

  // Pattern 2: Two parents + new child
  const addChildToBothParents = async (parent1Id, parent2Id, childData, relationshipType = "child") => {
    const payload = {
      parent1_id: parent1Id,
      parent2_id: parent2Id,
      relationship_type: relationshipType,
      new_person_data: childData
    };

    return await createRelationship(payload);
  };

  // Pattern 3: Connect two existing people
  const connectExistingPeople = async (person1Id, person2Id, relationshipType) => {
    const payload = {
      person1_id: person1Id,
      person2_id: person2Id,
      relationship_type: relationshipType,
      family_context: "auto"
    };

    return await createRelationship(payload);
  };

  return {
    loading,
    error,
    addRelatedPerson,
    addChildToBothParents,
    connectExistingPeople,
    clearError: () => setError(null)
  };
};